// extracted by mini-css-extract-plugin
export default {"prompt":"ResultsTabContent_prompt__x0H3i","footer":"ResultsTabContent_footer__07CTO","linkButton":"ResultsTabContent_linkButton__UaKiP"};